import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import CustomButton from "../../../components/CustomButton";

const PayLaterPrompt = ({ show, onConfirm, onCancel }: any) => {
  return (
    <Modal
      disableAutoFocus
      open={show}
      onClose={() => onCancel()}
      aria-labelledby="pay-later-prompt"
      className={'modal-container'}
    >
      <div className={'modal-paper'}>
        <Box component="h3" m={1} className={'modal-title'}>
          Are you sure?
        </Box>
        <p className={'modal-sub-title'}>Once you click Continue, you won't be able to return to this page. Make sure you've reviewed your alternative payment options.</p>
        <Grid
          container
          className={'modal-button-container'}
        >
          <CustomButton
            variant="outlined"
            disableElevation={false}
            label={"cancel"}
            onClick={() => onCancel()}
            buttonSize={'modal-button-left'}
          />
          <CustomButton
            variant="contained"
            disableElevation={true}
            label={"continue"}
            onClick={() => onConfirm()}
          />
        </Grid>
      </div>
    </Modal>
  );
};

export default PayLaterPrompt;
